/* eslint-disable */
// /src/pages/NoEmailHarvestPage.jsx
// DH Mobility — 이메일주소 무단수집 거부 안내 페이지

import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Container from "../components/Container";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #f7faff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;

const TopBar = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;

  button {
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    color: #111827;
    font-size: 14px;
    font-weight: 600;
    padding: 6px 8px;
    border-radius: 8px;
  }

  button:active {
    transform: translateY(1px);
  }

  svg {
    width: 18px;
    height: 18px;
  }

  h1 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #111827;
  }
`;

const Body = styled.div`
  flex: 1;
  padding: 20px 16px 32px;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 8px 0 16px;
`;

const Paragraph = styled.p`
  font-size: 14px;
  line-height: 1.7;
  color: #374151;
  margin-bottom: 10px;
`;

const Small = styled.p`
  font-size: 12px;
  line-height: 1.7;
  color: #6b7280;
  margin-top: 18px;
`;

export default function NoEmailHarvestPage() {
    const navigate = useNavigate();

    const handleBack = () => {
        // 이전 페이지로 돌아가되, 없으면 홈으로
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate("/home", { replace: true });
        }
    };




    return (
        <Wrap>
            <Container noPadding full>
                <Sheet>
                    <TopBar>
                        <button type="button" onClick={handleBack}>
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#111"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <polyline points="15 18 9 12 15 6" />
                            </svg>
                            <span>뒤로가기</span>
                        </button>
              
                    </TopBar>

                    <Body>
                        <Title>이메일주소 무단수집 거부 안내</Title>

                        <Paragraph>
                            본 서비스에 게시된 이메일 주소가 전자우편 수집 프로그램이나
                            그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을
                            명시적으로 거부합니다.
                        </Paragraph>

                        <Paragraph>
                            이를 위반하여 무단으로 이메일 주소를 수집하거나,
                            무단 광고성 이메일(E-mail)을 발송하는 행위는
                            「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등
                            관련 법령에 따라 형사 처벌의 대상이 될 수 있습니다.
                        </Paragraph>

                        <Paragraph>
                            또한 당사의 동의 없이 본 사이트 내 이메일 주소를 수집하여
                            영리 목적의 광고, 스팸메일 발송, 고객정보 판매 등으로
                            사용하는 행위를 엄격히 금지합니다.
                        </Paragraph>

                        <Small>
                            위 정책은 이용자 개인정보 보호 및 건전한
                            전자 통신 환경 조성을 위한 것으로,
                            당사의 모든 온라인 서비스에 동일하게 적용됩니다.
                        </Small>
                    </Body>
                </Sheet>
            </Container>
        </Wrap>
    );
}
